import { render, staticRenderFns } from "./customdialog.vue?vue&type=template&id=4abffad8&"
import script from "./customdialog.vue?vue&type=script&lang=js&"
export * from "./customdialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports